<template>
        <div class="warp">
            <!-- 查询条件 -->
            <div class="retrieve" ref="condition">
                <div class="right">
                    <el-button 
                    icon="el-icon-plus"
					type="primary" 
					size="small" 
					v-if="authorities.indexOf('sys:permission:background:web:config:guarantee:file:button:add')!=-1"
					@click="add"
					>添加</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                 ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    show-overflow-tooltip
                    
                    label="附件">
                    <template slot-scope="scope">
                        <div class="tableName" @click="downLoad(scope.row)">{{scope.row.fileName}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="发布账号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    label="发布时间">
                </el-table-column>
                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:web:config:guarantee:file:button:delete')!=-1"
                    label="操作"
                    
                    width="200">
                    <template slot-scope="scope">
                        <el-button 
						size="small" type="danger" class="super" plain
						v-if="authorities.indexOf('sys:permission:background:web:config:guarantee:file:button:delete')!=-1"
						@click="del(scope.row)"
						>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 弹出层 -->
            <el-dialog
                title="添加附件"
                :visible.sync="dialogUpload"
                width="30%">
                <div class="forms">
                    <div class="attachment">
                        <div class="name"><span>*</span>附件：</div>
                        <div class="content">
                            <upLoadFiles  v-model="sendInfo.fileList" :alone="true" 
							:action="'backstage/annex/file'" :size="20"/>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.fileList']">错误提示：{{errors['sendInfo.fileList']}}</div>

                    <div class="doubleBtn">
                        <el-button type="primary" @click="cancel">取消</el-button>
                        <el-button type="primary" @click="submit">确认</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
</template>

<script>
import upLoadFiles from '../../../components/upLoadFiles';
import {onDownload} from "@/utils/common";
export default {
    components:{
        upLoadFiles
    },
	props: ['iData','tab'],
    data(){
        return{
          loading:false,
          bHeight: void 0,
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            tableData:[],//表格数据
            sendInfo:{
                fileList:[],//附件
            },
            dialogUpload:false,//上传弹出层
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfo.fileList':{
            test:function(){
                if(this.sendInfo.fileList.length>0){
                    return true;
                }else{
                    return false;
                }
            },
            message:'上传附件'
        }
    },
    mounted(){
        const that= this
        that.getData()
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 75
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 75
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    },
    methods:{
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        getData(){
            this.loading = true
            this.$axiosc.get('backstage/front/config/file/list/'+1).then(res=>{
                this.loading = false
                if(res.code == 200){
                    this.tableData = res.data
                }else{
                    this.$message({
                        type: 'success',
                        message: res.msg
                    });
                }
            }).catch(e=>{
              this.loading = false
            })
        },
        //下载附件
        // down:function(item){
        //     window.open(item.frontPath+item.filePath)
        // },
        downLoad:function({fileName,filePath}){
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
        //删除
        del:function(row){
			let _this=this;
            this.$confirm('是否删除？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
				this.$axiosc.delete('backstage/front/config/file/del/'+row.id).then(res=>{
				    if(res.code == 200){
				        _this.getData()
				        _this.$message({
				            type: 'success',
				            message: '删除成功!'
				        });
				    }else{
				        _this.$message({
				            type: 'error',
				            message: res.msg
				        });
				    }
				})
               
            }).catch(() => {});
        },
		dell(){
			
		},
        //添加附件
        add:function(){
			      // this.$vuerify.clear();
            // this.dialogUpload=true;
            this.$router.push({path:'/systemLayout/configuration/configurationThird/add'})
        },
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                let parme = this.sendInfo.fileList[0]
                parme.type = 1
                this.$axioscBody.post('backstage/front/config/file/save',parme).then(res=>{
                    if(res.code == 200){
                        this.getData()
                        this.dialogUpload = false
                        this.$message({
                            type: 'success',
                            message: '添加成功!'
                        })
						this.sendInfo.fileList = [];
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        })
                    }
                    
                })
            }
        },
        //取消
        cancel:function(){
            this.dialogUpload=false;
            this.sendInfo.name1=[];
            this.$vuerify.clear();
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
    .retrieve{
        padding: 0;
        margin-bottom: 20px;
        .child{
            margin: 0;
        }
        .right{
            margin: 0;
        }
    }
}
</style>